import { Component, OnInit } from '@angular/core';
// import { Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
// import { EstacaoService } from 'src/app/shared/services/estacao.service';

@Component({
  selector: 'app-ativar-gps',
  templateUrl: './ativar-gps.component.html',
  styleUrls: ['./ativar-gps.component.scss'],
})
export class AtivarGpsComponent implements OnInit {
  private prefixoRota: string;
  private isDesktop: boolean;
  isHybrid = false;

  constructor(
    private platform: Platform,
    private modalCtrl: ModalController) { }

  ngOnInit() {
    this.isDesktop = this.platform.is('desktop') &&
      !this.platform.is('mobile') &&
      !this.platform.is('mobileweb');
    this.prefixoRota = this.isDesktop ? '' : '/tabs';
    this.isHybrid = this.platform.is('hybrid');
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
